/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  DockAddition,
  DockAdditionInput,
  DockAdditions,
  DockAdditionsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new DockAddition
 */
export const createDockAddition = (
    dockAdditionInput: MaybeRefOrGetter<DockAdditionInput>,
 signal?: AbortSignal
) => {
      dockAdditionInput = toValue(dockAdditionInput);

      return axiosClient<DockAddition>(
      {url: `/dock-additions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dockAdditionInput, signal
    },
      );
    }




export const getCreateDockAdditionMutationKey = () => ['createDockAddition'] as const;

export const getCreateDockAdditionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDockAddition>>, TError,CreateDockAdditionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createDockAddition>>, TError,CreateDockAdditionMutationVariables, TContext> => {

const mutationKey = getCreateDockAdditionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDockAddition>>, CreateDockAdditionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createDockAddition(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDockAdditionMutationResult = NonNullable<Awaited<ReturnType<typeof createDockAddition>>>
    export type CreateDockAdditionMutationBody = DockAdditionInput
    export type CreateDockAdditionMutationError = ErrorType<ValidationError | StandardError>
    export type CreateDockAdditionMutationVariables = {data: DockAdditionInput}

    /**
 * @summary Create new DockAddition
 */
export const useCreateDockAddition = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDockAddition>>, TError,CreateDockAdditionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createDockAddition>>,
        TError,
        CreateDockAdditionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateDockAdditionMutationOptions(options), queryClient);
    }
    /**
 * @summary DockAdditions list
 */
export const dockAdditions = (
    params?: MaybeRefOrGetter<DockAdditionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<DockAdditions>(
      {url: `/dock-additions`, method: 'GET',
        params, signal
    },
      );
    }




export const getDockAdditionsQueryKey = (params?: MaybeRefOrGetter<DockAdditionsParams>,) => {
    return [
    'dock-additions', ...(params ? [params] : [])
    ] as const;
    }


export const getDockAdditionsQueryOptions = <TData = Awaited<ReturnType<typeof dockAdditions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<DockAdditionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockAdditions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDockAdditionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dockAdditions>>> = ({ signal }) => dockAdditions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dockAdditions>>, TError, TData>
}

export type DockAdditionsQueryResult = NonNullable<Awaited<ReturnType<typeof dockAdditions>>>
export type DockAdditionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary DockAdditions list
 */

export function useDockAdditions<TData = Awaited<ReturnType<typeof dockAdditions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<DockAdditionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockAdditions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDockAdditionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary DockAddition destroy
 */
export const destroyDockAddition = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/dock-additions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyDockAdditionMutationKey = () => ['destroyDockAddition'] as const;

export const getDestroyDockAdditionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDockAddition>>, TError,DestroyDockAdditionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyDockAddition>>, TError,DestroyDockAdditionMutationVariables, TContext> => {

const mutationKey = getDestroyDockAdditionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyDockAddition>>, DestroyDockAdditionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyDockAddition(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyDockAdditionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyDockAddition>>>

    export type DestroyDockAdditionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyDockAdditionMutationVariables = {id: string}

    /**
 * @summary DockAddition destroy
 */
export const useDestroyDockAddition = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyDockAddition>>, TError,DestroyDockAdditionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyDockAddition>>,
        TError,
        DestroyDockAdditionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyDockAdditionMutationOptions(options), queryClient);
    }
    /**
 * @summary Get DockAddition
 */
export const dockAddition = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<DockAddition>(
      {url: `/dock-additions/${id}`, method: 'GET', signal
    },
      );
    }




export const getDockAdditionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'dock-additions',id
    ] as const;
    }


export const getDockAdditionQueryOptions = <TData = Awaited<ReturnType<typeof dockAddition>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockAddition>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getDockAdditionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof dockAddition>>> = ({ signal }) => dockAddition(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof dockAddition>>, TError, TData>
}

export type DockAdditionQueryResult = NonNullable<Awaited<ReturnType<typeof dockAddition>>>
export type DockAdditionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get DockAddition
 */

export function useDockAddition<TData = Awaited<ReturnType<typeof dockAddition>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof dockAddition>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDockAdditionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






